import { useLocation, useParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { useHeaderMeta } from 'pages/tours/search-result-page/model'

import { selectionStore } from 'entities/tour/models'
import tourList from 'entities/tour/models/tour-list/tour-list'
import { TourDetail } from 'entities/tour/ui/tour-detail'

import { useHotelDetails } from './model/hooks/useHotelDetails'

const TourDetailPage = observer(() => {
  const { hotelId, sharingCode } = useParams<{
    hotelId: string
    sharingCode: string
  }>()
  const state = useLocation().state

  const { title, subtitle, isViewMode, hotel } = state || {}

  const { title: titleFromMeta, subtitle: subtitleFromMeta } = useHeaderMeta()
  const { isLoading, isError, isRoomLoading } = useHotelDetails(
    hotelId,
    sharingCode,
    isViewMode,
  )

  const hotelDetail = hotel || selectionStore.getSelectedHotel()
  const hotelSearchSessionId = tourList.getUid()

  return (
    <TourDetail
      isSharingMode={!!sharingCode}
      isError={isError}
      isLoading={isLoading}
      isRoomLoading={isRoomLoading}
      hotelDetail={hotelDetail}
      isViewMode={isViewMode}
      title={title || titleFromMeta}
      subtitle={subtitle || subtitleFromMeta}
      hotelSearchSessionId={hotelSearchSessionId || ''}
    />
  )
})

export default TourDetailPage
